<template>
  <vue-final-modal
    v-model="showModal"
    classes="modal-container"
    content-class="modal-content"
    name="newsletter"
    @click-outside="closeModal"
  >
    <slot></slot>
  </vue-final-modal>
</template>

<script>
export default {
  computed: {
    showModal: {
      get() {
        return this.$store.state.menu.openNewsletterModal
      },
      set(v) {
        if (v) {
          this.$store.dispatch('menu/openNewsletterModal')
        } else {
          this.$store.dispatch('menu/closeNewsletterModal')
        }
      }
    }
  },
  methods: {
    closeModal() {
      this.$store.dispatch('menu/closeNewsletterModal')
    }
  }
}
</script>
